import { cn, platformProps } from "../../lib";
import { Box } from "../../primitives";
import { useChatBubbleContext } from "./chat-bubble-context";
import type { ChatBubbleBodyProps } from "./types";

/** Bubble container — receives the fill, max-width, and asymmetric tail corner. */
const bodyVariantClass = {
  sender: "bg-luce-brand-primary rounded-radius-2xl rounded-tr-radius-sm",
  receiver: "bg-luce-neutral-background-intermediate rounded-radius-2xl rounded-tl-radius-sm",
  system: "bg-luce-neutral-background-attenuated rounded-radius-md items-center text-center",
};

/**
 * The bubble container — receives the fill, max-width, and tail corner radius.
 * Slots (Author / Content / Attachments / Timestamp) render in JSX order.
 */
export const ChatBubbleBody = ({ children, className, testID }: ChatBubbleBodyProps) => {
  const { variant } = useChatBubbleContext();

  return (
    <Box
      className={cn(
        "gap-spacing-xs px-spacing-md py-spacing-sm flex max-w-[75%] flex-col",
        bodyVariantClass[variant],
        className,
      )}
      {...platformProps({ testID, slot: "chat-bubble-body" })}
    >
      {children}
    </Box>
  );
};

ChatBubbleBody.displayName = "ChatBubble.Body";
